import ModalHeader from '@molecules/ModalHeader';
import ModalWindow from '@organisms/modals/ModalWindow';
import {FC, useState} from 'react';
import {ButtonsWrapper, ModalContent, ModalWrapper} from './EditPasswordModal.styles';
import Button from '@atoms/Button';
import Input from '@atoms/Input';
import {ViewFilled, ViewOffFilled} from '@carbon/icons-react';
import {theme} from '@styles/theme';
import Toast from '@atoms/Toast';
import {toast} from 'react-toastify';
import {useDispatch} from 'react-redux';
import {AppDispatch} from '@store';
import {updatePassword as updatePasswordThunk} from '@store/slices/profile';

interface Props {
  isOpened: boolean;
  onCloseRequest: () => void;
}

const EditPasswordModal: FC<Props> = ({isOpened, onCloseRequest}) => {
  const [curPassValue, setCurPassValue] = useState<string>();
  const [newPassValue, setNewPassValue] = useState<string>();
  const [repeatPassValue, setRepeatPassValue] = useState<string>();
  const [curPassFieldType, setCurPassFieldType] = useState<'password' | 'text'>(
    'password',
  );
  const [newPassFieldType, setNewPassFieldType] = useState<'password' | 'text'>(
    'password',
  );
  const [repeatPassFieldType, setRepeatPassFieldType] = useState<'password' | 'text'>(
    'password',
  );

  const dispatch = useDispatch<AppDispatch>();

  const onSave = () => {
    if (!curPassValue || !newPassValue || newPassValue !== repeatPassValue) return;
    onCloseRequest();
    dispatch(
      updatePasswordThunk({last_password: curPassValue, new_password: newPassValue}),
    )
      .unwrap()
      .then(() => {
        toast.success(
          <Toast title="Готово!" text="Пароль успешно изменен" type="success" />,
        );
      })
      .catch((err: any) => {
        toast.error(
          <Toast
            title="Ошибка"
            text={err?.message || 'Не удалось изменить пароль'}
            type="error"
          />,
        );
      });
  };

  return (
    <ModalWindow isOpen={isOpened} overflowIsVisible>
      <ModalWrapper>
        <ModalHeader title={'Изменить пароль'} onClose={onCloseRequest} />
        <ModalContent>
          <Input
            id="current-password"
            label="Текущий Пароль"
            type={curPassFieldType}
            value={curPassValue}
            onChange={e => {
              setCurPassValue(e.currentTarget.value);
            }}
            iconElement={
              curPassFieldType == 'password' ? (
                <ViewOffFilled size={16} color={theme.colors.basic02} />
              ) : (
                <ViewFilled size={16} color={theme.colors.basic02} />
              )
            }
            onClickIcon={() =>
              setCurPassFieldType(curPassFieldType == 'password' ? 'text' : 'password')
            }
            withoutErrorText
          />

          <Input
            id="new-password"
            label="Новый пароль"
            type={newPassFieldType}
            value={newPassValue}
            onChange={e => {
              setNewPassValue(e.currentTarget.value);
            }}
            iconElement={
              newPassFieldType == 'password' ? (
                <ViewOffFilled size={16} color={theme.colors.basic02} />
              ) : (
                <ViewFilled size={16} color={theme.colors.basic02} />
              )
            }
            onClickIcon={() =>
              setNewPassFieldType(newPassFieldType == 'password' ? 'text' : 'password')
            }
            withoutErrorText
            hint="Не менее 8 символов, строчные и заглавные буквы, цифры и спецсимволы"
          />

          <Input
            id="repeat-password"
            label="Повторите новый пароль"
            type={repeatPassFieldType}
            value={repeatPassValue}
            onChange={e => {
              setRepeatPassValue(e.currentTarget.value);
            }}
            iconElement={
              repeatPassFieldType == 'password' ? (
                <ViewOffFilled size={16} color={theme.colors.basic02} />
              ) : (
                <ViewFilled size={16} color={theme.colors.basic02} />
              )
            }
            onClickIcon={() =>
              setRepeatPassFieldType(
                repeatPassFieldType == 'password' ? 'text' : 'password',
              )
            }
            withoutErrorText
          />
        </ModalContent>
        <ButtonsWrapper>
          <Button
            onClick={onSave}
            fullWidth
            title="Изменить"
            variant="filled"
            disabled={!curPassValue || !newPassValue || newPassValue != repeatPassValue}
          />
          <Button
            fullWidth
            title="Закрыть"
            onClick={() => {
              onCloseRequest();
            }}
          />
        </ButtonsWrapper>
      </ModalWrapper>
    </ModalWindow>
  );
};

export default EditPasswordModal;
